module.exports = "<div class=\"style\" *ngFor=\"let styleImage of styleImages\">\n    <img\n        class=\"img-style\"\n        src=\"{{ styleImage.image }}\"\n        title=\"{{ styleImage.style.name }}\"\n        (click)=\"setStyle(styleImage.style)\"><br>\n    <img\n        class=\"img-shadow\"\n        *ngIf=\"compareStyles(styleImage.style, style)\"\n        src=\"{{shadowImg}}\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/components/map-config-style/map-config-style.component.html
// module id = ../../../../../src/app/components/map-config-style/map-config-style.component.html
// module chunks = main